export const ARTICLESET = "article/set";
export const ADMINSET = "admin/set";
export const RESETALL = "reset/all";
